import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, InputAdornment } from "@material-ui/core";
import classNames from "classnames";
import { FC } from "react";
import plate_number_image from "../../../images/plate_number_image.png";
import { InputTextMask, InputTextMaskProps } from "../InputTextMask";
import "./index.scss";

interface PlateNumberInputProps extends InputTextMaskProps {
    value?: string;
    small?: boolean;
    label?: string;
    validationError?: string;
    onSearchListener?: (value: string) => void;
}

export const PlateNumberInput: FC<PlateNumberInputProps> = ({
    name,
    value,
    error,
    validationError,
    formatResponse,
    small,
    onChange,
    onSearchListener,
}) => {
    const formatCharts = {
        a: "[A-ZА-ЯІa-zа-яі]",
        "9": "[0-9]",
    };

    const translitMap: Record<string, string> = {
        A: "А",
        B: "В",
        C: "С",
        E: "Е",
        H: "Н",
        I: "І",
        K: "К",
        M: "М",
        O: "О",
        P: "Р",
        T: "Т",
        Y: "У",
        X: "Х",
    };

    const replace = (value: string): string => {
        let result = value;

        for (let i = 0; i < value.length; i++) {
            Object.keys(translitMap).forEach((latinSymbol) => {
                if (value.charAt(i) === latinSymbol) {
                    result =
                        result.substring(0, i) + translitMap[latinSymbol] + value.substring(i + 1);
                }
            });
        }

        return result;
    };

    const className = classNames({
        "plate-number-input": true,
        "plate-number-input_small": small,
    });

    const complete = value?.length === 8;

    return (
        <div className={"plate-number"}>
            <div className={`${className}`}>
                <div className={"plate-number-input__image"}>
                    <img
                        style={{ borderTopLeftRadius: "4px", borderBottomLeftRadius: "4px" }}
                        src={plate_number_image}
                        alt={""}
                    />
                </div>
                <div className={"plate-number-input__input"}>
                    <InputTextMask
                        name={name}
                        value={value}
                        onChange={onChange}
                        formatResponse={formatResponse}
                        beforeChange={(value: string) => {
                            return replace(value);
                        }}
                        formatChars={formatCharts}
                        mask={"aa 9999 aa"}
                        toUpperCase={true}
                        endAdornment={
                            complete &&
                            onSearchListener && (
                                <InputAdornment position={"end"}>
                                    <IconButton
                                        onClick={() => {
                                            onSearchListener(value);
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faArrowRight as any}
                                            className={"plate-number-input__input-svg"}
                                        />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }
                        placeholder={"АА 1234 АА"}
                        error={error}
                    />
                </div>
            </div>
            {error && (
                <p
                    className={
                        "MuiFormHelperText-root MuiFormHelperText-contained Mui-error MuiFormHelperText-filled"
                    }
                >
                    {validationError}
                </p>
            )}
        </div>
    );
};
